import './index.css';
import { isValidElement } from 'react';

const isActionBarComponent = (component) => {
    return (isValidElement(component) &&
        typeof component.type === 'function' &&
        'isActionBar' in component?.type);
};

export { isActionBarComponent };
//# sourceMappingURL=types.js.map
